import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class ComponentPropertyHtmlBridgePrototype extends HtmlBridgePrototype{

    public propertyName:string;
    
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ComponentPropertyHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class ComponentPropertyHtmlBridge extends HtmlBridge{
    
    private propertyName:string;
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    private componentViewModel : ViewModel;

    constructor(prototype:ComponentPropertyHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.propertyName = prototype.propertyName;
    }
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.componentViewModel = (<any>node).binderRelatedView.dataContext
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this.componentViewModel,this.propertyName));
    }

    public release(){
        this.binding.release();
    }
}